<template>
<div>
    
    <div style="width:100%; padding-top:200px; height:60px; color:#ffcd00; font-size:30px; text-align:center; line-height:20px;">메인이동중..<br>
<span style="font-size:12px;color:#c9c9c9;">잠시만 기다려 주세요. 메인이동중입니다.</span>

    </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'home',
  mounted(){

 
              this.$parent.$router.push("/shop/hair/1")

  },
data(){
  return {
    items: [],
    modalDesc: {
      item: {},
      buyPrice: ""

    },
    alertModal: "",
    currentPage: 1,
    currentType: "weapon"
  }
}
}
</script>